<div class="question-type__text">
  <h1 class="fs__xxl">Demographic questions</h1>
  <p class="fs__md">Question that will add to the survey all the default demographic questions</p>
  <h2 class="fs__lg">Questions Included</h2>
  <p class="fs__md">Once added to the survey, the questions can be re-organized or removed if needed.</p>
  <ul class="question-type__bullet-points">
    <li class="fs__sm">
      <span class="text fw__500">Gender</span>
      <span class="sub-text">What is your gender?</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Age</span>
      <span class="sub-text">What age are your?</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Region</span>
      <span class="sub-text">In which of the following counties do you currently live?</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Employment status</span>
      <span class="sub-text">What is your current employment status?</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Occupational group</span>
      <span class="sub-text">
        Please indicate to which occupational group the chief income earner in your household belongs, or which group fits best. The chief income earner is the
        person in your household with the largest income; this could be yourself or another person in your household.
      </span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Children</span>
      <span class="sub-text">Do you have any children under 18 living with you?</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Children</span>
      <span class="sub-text">Do you have any dependent children living with you who are aged ...?</span>
    </li>
  </ul>
</div>
